import * as React from "react";
import { forwardRef } from "react";
const SvgEmpty = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props });
const ForwardRef = forwardRef(SvgEmpty);
export default ForwardRef;
